<mat-icon *ngIf="fieldWrapperShown && isKeyVisible"  class="form-wrapper-edit" (click)="openFieldWrapperDialog()"> vpn_key</mat-icon>
<ng-container #fieldComponent></ng-container>
<!-- FIELD WRAPPER MODAL STARTS HERE-->
<ng-template #fieldWrapperDialog>
  <div class="modal-header">
      <h4 class="modal-title pull-left no-margin">Override Key</h4>
  </div>
  <div class="modal-body">
    <app-metadata-field [data]="data"></app-metadata-field>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-default reject-button" (click)="modalRefConf.hide();" *ngIf="iskeyOverwritePossible">Close</button>
      <button type="button" class="btn btn-danger reject-button" (click)="OverrideKey(); modalRefConf.hide()" *ngIf="iskeyOverwritePossible">Override Key</button>
      <span *ngIf="!iskeyOverwritePossible" class="danger">Unable to overwrite key for this.</span>
  </div>
</ng-template>
<!-- FIELD WRAPPER MODAL STARTS HERE-->